import Vue from 'vue'

export const dictionarySortBus = new Vue()
